// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__XyxF+","title":"style_title__iFVhe","text":"style_text__jJd6q","CTA":"style_CTA__PyjWr"};